import { useEffect, useState } from "react";
import { api, type OwnerState, type Principal } from "../lib/api";
import { Card, Cards, PageHead, Pill, Section } from "../components/owner";
import { channelLabels } from "./declaredReview";
import { seatWords } from "./words";

/** People are platform identity records; memory and business identity belong to plugins. */
export function IdentityPage({ version, owner, principals, accountName, onGo }: {
  version: number; owner: OwnerState; principals: Principal[]; onGo: (hash: string) => void;
  /** What the account that owns this Agent is called; the owner has no name of his own on the Agent. */
  accountName?: string;
}) {
  const people = principals.filter(person => !person.revoked);
  // The channels' own titles, so 「Discord」 reads as that and not as a count.
  const [labels, setLabels] = useState<Record<string, string>>({});
  useEffect(() => {
    let live = true;
    api.capabilities().then(body => live && setLabels(channelLabels(body.registries))).catch(() => {});
    return () => { live = false; };
  }, [version]);
  return <div className="own identity-directory">
    <PageHead kicker="当前 IP" title="谁能与这个 IP 对话" lead="查看已关联的人和渠道账号。聊天权限在“预算与授权”中设置。" />
    <Section icon="person" title="已关联的人" count={people.length} lead="每个人可以关联多个渠道账号。">
      {people.length ? <Cards>{people.map(person => <Card key={person.id}
        title={person.display_name || (person.role === "owner" ? accountName || "你本人" : "联系人")} quotedTitle
        badge={<Pill tone={person.role === "owner" ? "good" : "neutral"}>{person.role === "owner" ? "你本人" : "联系人"}</Pill>}>
        <p>{person.channels?.length ? `联系渠道：${seatWords(person.channels, labels).join("、")}` : "尚未登记渠道账号"}</p>
      </Card>)}</Cards> : <p className="identity-empty">当前没有可显示的联系人。</p>}
      {owner.identities > people.length ? <p className="micro">同一个人可以关联多个账号。</p> : null}
    </Section>
    <button className="btn" onClick={() => onGo("#/connections")}>查看权限与账号设置</button>
    <button className="btn" onClick={() => onGo("#/chat")}>回到这个 IP 的对话</button>
  </div>;
}
